export const getTitleCopy = (type, allowsDecliningEmployees) => {
  let title;

  if (type === "single_owner" || type === "multiple_owners") {
    title = allowsDecliningEmployees ? "Offer Coverage to a Non-Owner Employee" : "Add a Non-Owner Enrollee";
  } else if (type === "owner_and_spouse") {
    title = `${allowsDecliningEmployees ? "Offer Coverage to an Employee" : "Add An Enrollee"} Who is Not Owner or Spouse`;
  }

  return title;
};

export const getLabelCopy = (type, allowsDecliningEmployees) => {
  let preamble;

  if (type === "single_owner") {
    preamble = "";
  } else if (type === "multiple_owners") {
    preamble = "It appears that all enrollees are non-payroll owners of the company.";
  } else if (type === "owner_and_spouse") {
    preamble = "It appears that the two enrollees are married and at least one is the company owner.";
  }

  return `${preamble} The Insurance Carrier requires that at least one non-owner or spouse ${
    allowsDecliningEmployees ? "is offered coverage even if they choose to decline" : "enrolls in coverage"
  }. Please choose from the following:`;
};

export const getOptions = (type, ownerName, alternativeCarriers, allowsDecliningEmployees) => {
  const name = ownerName || "The sole enrollee";
  const allowsDecliningClause = `${allowsDecliningEmployees ? "can be offered" : "will enroll in"} coverage`;

  let notOwnerOrSpouse;
  const modifyEmployeesEnrollingInMedical = `I have another non-owner employee who ${allowsDecliningClause}`;
  const selectAlternativePlan = "I will choose a plan from another carrier that doesn't have this requirement";
  let ownerIsOnlyEnrollee;

  if (type === "single_owner") {
    notOwnerOrSpouse = `${name} is not the company owner or spouse of the owner`;
    ownerIsOnlyEnrollee = `${name} is the owner or spouse of the owner and the only person who ${allowsDecliningClause}`;
  } else if (type === "multiple_owners") {
    notOwnerOrSpouse = "Not all enrollees are owners of the company (or spouses of owners)";
    ownerIsOnlyEnrollee = `There are no non-owners who ${allowsDecliningClause}`;
  } else if (type === "owner_and_spouse") {
    notOwnerOrSpouse = "The two current enrollees are not the owner and the owner's spouse";
    ownerIsOnlyEnrollee = `There are no non-owners who ${allowsDecliningClause}`;
  }

  const options = {
    notOwnerOrSpouse,
    modifyEmployeesEnrollingInMedical,
    selectAlternativePlan,
    ownerIsOnlyEnrollee,
  };

  if (alternativeCarriers.length == 0) {
    delete options.selectAlternativePlan;
  }

  return options;
};
